import React from "react";

import { faCalculatorSimple, faCode } from "@fortawesome/pro-regular-svg-icons";

import { useCapabilities } from "src/hooks/useCapabilities";
import { BreadcrumbType, PageHeader } from "src/layout/PageHeader";
import { SubHeader, SubHeaderTab, SubHeaderTabs } from "src/layout/SubHeader";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";
import {
  DashboardPageParams,
  getUrlToFeaturesPage,
  getUrlToQueryPreviewPage,
} from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type FeatureHeaderProps = {
  subHeaderRightContent?: React.ReactNode;
  showSubHeader?: boolean;
  breadcrumbs: { key: string; breadcrumb: ReturnType<BreadcrumbType> }[];
  sideContent?: React.ReactNode;
};

export const FeatureQueryHeader: React.FC<FeatureHeaderProps> = ({
  subHeaderRightContent,
  showSubHeader = true,
  breadcrumbs,
  sideContent,
}) => {
  const { featureQueriesCatalogue } = useCapabilities();
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  const featureLifecycleEnabled = isFeatureFlagEnabled(
    FEATURE_FLAGS.featureLifecycle,
  );

  return (
    <>
      <PageHeader
        {...(breadcrumbs.length > 0
          ? { breadcrumbs }
          : { title: `${featureLifecycleEnabled ? "" : "Features"}` })}
        sideContent={sideContent}
      />
      {showSubHeader && (
        <SubHeader
          leftSlot={
            <>
              {featureLifecycleEnabled ? (
                <span className="font-inter-semibold-14px text-gray-800">
                  Features
                </span>
              ) : (
                <SubHeaderTabs>
                  <SubHeaderTab
                    icon={faCalculatorSimple}
                    to={getUrlToFeaturesPage(orgId, wsId)}
                    end
                  >
                    Features
                  </SubHeaderTab>
                  {featureQueriesCatalogue.canAccess && (
                    <SubHeaderTab
                      icon={faCode}
                      to={getUrlToQueryPreviewPage(orgId, wsId)}
                    >
                      Queries
                    </SubHeaderTab>
                  )}
                </SubHeaderTabs>
              )}
            </>
          }
        >
          {subHeaderRightContent ?? null}
        </SubHeader>
      )}
    </>
  );
};
